import React from 'react';
import { FiHome, FiPackage, FiBell, FiUser, FiTrendingUp, FiCreditCard, FiDollarSign, FiHeadphones, FiSettings, FiLogOut, FiChevronRight } from 'react-icons/fi';

export default function LogisticProfileScreen() {
  const menuItems = [
    { icon: <FiTrendingUp size={24} />, label: 'Dashboard' },
    { icon: <FiCreditCard size={24} />, label: 'Profile' },
    { icon: <FiDollarSign size={24} />, label: 'Payments' },
    { icon: <FiHeadphones size={24} />, label: 'Contact Us' },
    { icon: <FiSettings size={24} />, label: 'Settings' },
    { icon: <FiLogOut size={24} />, label: 'Logout' },
  ];

  return (
    <div className="min-h-screen bg-[#F1F3F2] flex flex-col max-w-md mx-auto relative">
      {/* Status Bar */}
      <div className="bg-[#19C463] text-white px-5 pt-3 pb-2 flex justify-between items-center text-sm font-semibold">
        <span>10:33</span>
        <div className="flex items-center gap-2">
          <svg width="18" height="14" viewBox="0 0 18 14" fill="currentColor">
            <rect x="0" y="10" width="3" height="4" rx="0.5" />
            <rect x="5" y="7" width="3" height="7" rx="0.5" />
            <rect x="10" y="3" width="3" height="11" rx="0.5" />
            <rect x="15" y="0" width="3" height="14" rx="0.5" />
          </svg>
          <svg width="18" height="14" viewBox="0 0 18 14" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M1 5C5 1 13 1 17 5" strokeLinecap="round" />
            <path d="M5 8.5C7.5 6 10.5 6 13 8.5" strokeLinecap="round" />
            <circle cx="9" cy="12" r="1" fill="currentColor" stroke="none" />
          </svg>
          <svg width="24" height="14" viewBox="0 0 24 14" fill="currentColor">
            <rect x="0" y="1" width="20" height="12" rx="2" stroke="currentColor" strokeWidth="1.5" fill="none" />
            <rect x="2" y="3" width="14" height="8" rx="1" />
            <path d="M22 5V9C23 8.5 23 5.5 22 5Z" />
          </svg>
        </div>
      </div>

      {/* Header */}
      <div className="bg-[#19C463] text-white px-5 pb-6 pt-4">
        <h1 className="text-xl font-bold text-center">Welcome User Name!</h1>
      </div>

      {/* Main Content */}
      <div className="flex-1 bg-[#F1F3F2] px-4 -mt-4 pb-24">
        <div className="bg-white rounded-lg shadow-sm overflow-hidden">
          {menuItems.map((item, index) => (
            <div 
              key={index} 
              className={`flex items-center justify-between px-5 py-4 ${
                index !== menuItems.length - 1 ? 'border-b border-gray-100' : ''
              }`}
            >
              <div className="flex items-center gap-4">
                <span className="text-black">{item.icon}</span>
                <span className="text-base font-semibold text-black">{item.label}</span>
              </div>
              <FiChevronRight size={20} color="#000000" />
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Navigation */}
      <div className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md bg-white border-t border-gray-200 flex justify-around items-center py-2 pb-4 px-2">
        <div className="flex flex-col items-center gap-1 cursor-pointer">
          <FiHome size={24} color="#19C463" strokeWidth={2} />
          <span className="text-xs text-[#19C463] font-bold">Home</span>
        </div>
        <div className="flex flex-col items-center gap-1 cursor-pointer">
          <FiPackage size={24} color="#000000" strokeWidth={2} />
          <span className="text-xs text-black font-medium">Deliveries</span>
        </div>
        <div className="flex flex-col items-center gap-1 cursor-pointer">
          <FiBell size={24} color="#000000" strokeWidth={2} />
          <span className="text-xs text-black font-medium">Notification</span>
        </div>
        <div className="flex flex-col items-center gap-1 cursor-pointer relative">
          <div className="relative">
            <FiUser size={24} color="#000000" strokeWidth={2} />
            <span className="absolute -top-1 -right-2 bg-[#19C463] text-white text-xs w-4 h-4 rounded-full flex items-center justify-center font-bold">
              2
            </span>
          </div>
          <span className="text-xs text-black font-medium">Profile</span>
        </div>
      </div>
    </div>
  );
}
